import Auth from "@/utilities/auth"
import System from "@/utilities/system"
const signalR = require('@microsoft/signalr')
import { Loader } from "@googlemaps/js-api-loader"

export class ActualLocation{

    connection = null
    google = null

    ConnectHub(){
        return new Promise((resolve,reject)=>{
            this.connection = new signalR.HubConnectionBuilder().withUrl(System.BaseURL.URL + "/seyirgetactuallocationhub",{ 
                headers:{ CompanyId : Auth.companyId || null },
                transport: signalR.HttpTransportType.LongPolling 
            }).build()
            this.connection.start().then(function(s){ 
                System.Development ? console.log('SignalR Connected For Seyir Actual Location ') : null
                resolve() 
            }).catch(function (err) { reject(err) })
        })
    }

    ConnectGoogle(){
        this.google = new Loader({apiKey: this.apiKey, libraries: ["places"]})
    }

    Listen(callback){
        this.connection.on('updateVehicleLocations', (c)=> { 
            callback(c)
        })
    }
}